import { defineStore } from 'pinia'
import state from '@/stores/chat/state'
import actionsStore from '@/stores/chat/actions'
import gettersStore from '@/stores/chat/getters'
import mutationsStore from '@/stores/chat/mutations'

export const useChatStore = defineStore('chat', () => {
  const getters = gettersStore(state)
  const mutations = mutationsStore(state)
  const actions = actionsStore(mutations)
  return {
    state,
    getters,
    mutations,
    actions,
  }
})
